import styles from './BenefitsCard.module.scss'

const BenefitsCard = () => {
  return (
    <div className={styles.wrapper}>
      <h2 className={styles.header}>Odbierz RABAT 10%</h2>
      <div className={styles.descriptionWrapper}>
        <p className={styles.description}>
          <b>Zapisując się do newslettera</b> - otrzymasz rabat o wartości 10%,
          dzięki czemu zakupy u nas będą nie tylko szybsze i wygodniejsze, ale
          przede wszystkim oszczędniejsze!
        </p>
      </div>
    </div>
  )
}

export default BenefitsCard
